import { Box, IconButton, Tooltip } from '@mui/material'
import ViewIcon from 'icons/ViewIcon';
import { colors } from 'styles/colors';

interface Props {
  onView: () => void;
}

// A report's action: open it in full, where it is also resolved.
export default function ContentReportActionButtons({ onView }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <Tooltip title={'View'}>
        <IconButton
          onClick={onView}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.view,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.view,
            },
          }}
        >
          <ViewIcon size={12} color='white' />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
